import { useAppRouter } from '@/common/route/useAppRouter';
import { StringUtils } from '@/common/utils/stringUtils';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';
import { avatarService } from '@/services/avatar';
import useVuelidate from '@vuelidate/core';
import { minValue, required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useAvatarCategoryAdd() {
    const route = useRoute();
    const router = useAppRouter();
    const { executeAction, excuteAndNotify } = useCrudActions();

    const model = reactive({
        parentId: StringUtils.toNumber(route.query.parentId),
        parentName: null,
        name: '',
        position: 0,
        gender: 0,
        isPublished: false,
        isRequired: false,
        posX: 0,
        posY: 0,
        isBody: false,
        imageFile: null
    });

    const validations = {
        name: { required },
        gender: { required },
        position: { required, min: minValue(0) }
    };

    const v$ = useVuelidate(validations, model);

    const actions = {
        fetch: executeAction({
            canExecute: () => model.parentId != null,
            request: () => avatarService.category.get(model.parentId),
            onSuccess: ({ data }) => (model.parentName = data?.name || StringUtils.Characters.Empty),
            onError: () => router.push({ name: ROUTE_NAME_AVATAR.CATEGORY.INDEX })
        }),
        create: excuteAndNotify({
            validator: v$,
            request: () =>
                avatarService.category.create(
                    model.parentId,
                    model.name,
                    model.position,
                    model.gender,
                    model.isPublished,
                    model.isRequired,
                    model.posX,
                    model.posY,
                    model.isBody,
                    model.imageFile
                ),
            onSuccess: () =>
                router.push({ name: ROUTE_NAME_AVATAR.CATEGORY.INDEX, query: { parentId: model.parentId, name: '' } })
        })
    };

    return { model, v$, actions };
}
